import { Decorative } from "@faire/design-tokens";
import { useFormattedOfferedMaxTerms } from "@faire/retailer-visitor-shared/hooks/openWithFaire/useFormattedOfferedMaxTerms";
import { useGetFaireAcademyPageState } from "@faire/retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { OWF_SECTION_NAME } from "@faire/retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackOpenWithFaireOwfApplicationCtaClick } from "@faire/web-api--source/events/openWithFaire/click/owfApplicationCta";
import owfApplication from "@faire/web-api--source/routes/www/net-terms/owf-application";
import * as React from "react";
import styled from "styled-components";

export const PaymentTermsUpsell: React.FC = () => {
  const formattedOfferedMaxTerms = useFormattedOfferedMaxTerms();
  const { pageState } = useGetFaireAcademyPageState();

  return (
    <SectionWrapper align="center">
      <ContentWrapper
        align={{ tabletAndAbove: "center", mobileAndAbove: "unset" }}
      >
        <Typography
          align={{
            tabletAndAbove: "center",
            mobileAndAbove: "start",
          }}
          variant={{
            tabletAndAbove: "displayMSerifRegular",
            mobileAndAbove: "displaySSerifRegular",
          }}
        >
          <StrictLocalMsg
            defaultMessage="Stock up your new store with up to {offeredMaxTermsMoney} in payment terms"
            description={{
              text: "Callout for retailer to apply for a payment terms increase",
              img: "https://cdn.faire.com/fastly/4127f16f890b70d42abac7dabe0e88abd72f8b426e12d651932958c968179cb6.png",
            }}
            values={{
              offeredMaxTermsMoney: formattedOfferedMaxTerms,
            }}
          />
        </Typography>
        <Spacer height="2x" />
        <Typography
          align={{
            tabletAndAbove: "center",
            mobileAndAbove: "start",
          }}
          variant={{
            tabletAndAbove: "subheadingSansRegular",
            mobileAndAbove: "paragraphSansRegular",
          }}
        >
          <StrictLocalMsg
            defaultMessage="As a new store owner, you qualify for extended payment terms to help you get the inventory you need."
            description={{
              text: "Explaining why retailer qualifies to apply for a payment terms increase",
              img: "https://cdn.faire.com/fastly/4127f16f890b70d42abac7dabe0e88abd72f8b426e12d651932958c968179cb6.png",
            }}
          />
        </Typography>
        <Spacer height="4x" />
        <Button
          linkTo={owfApplication()}
          onClick={() =>
            trackOpenWithFaireOwfApplicationCtaClick(
              pageState,
              OWF_SECTION_NAME.PAYMENT_TERMS_UPSELL
            )
          }
        >
          <StrictLocalMsg
            defaultMessage="Apply for more payment terms"
            description={{
              text: "Cta prompting retailer to apply for an increase in payment terms on Faire",
              img: "https://cdn.faire.com/fastly/4127f16f890b70d42abac7dabe0e88abd72f8b426e12d651932958c968179cb6.png",
            }}
          />
        </Button>
      </ContentWrapper>
    </SectionWrapper>
  );
};

const SectionWrapper = styled(Column)`
  width: 100%;
  background-color: ${Decorative.tint.neutral};
`;

const ContentWrapper = styled(Column)`
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing(102, "2x")};
    max-width: 525px;
  }

  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("5x", "2x")};
    width: 100%;
  }
`;
